module.exports = __webpack_public_path__ + "static/media/4-1.a87ed93a.webp";